import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import {
  BookingItemResourceInterface,
  BookingItemStatusEnum,
} from '@sport-activities/sdk';
import { Observable } from 'rxjs';

import { OrganizerSharedActivityService } from '~/organizer/shared/services/activity/activity.service';

export const OrganizerSharedTimeslotParticipantListByBookingIdResolver: ResolveFn<
  BookingItemResourceInterface[]
> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  activityService: OrganizerSharedActivityService = inject(
    OrganizerSharedActivityService
  )
): Observable<BookingItemResourceInterface[]> => {
  const timeslotId = route.paramMap.get('id');

  return activityService.getTimeslotBookingItems(
    timeslotId,
    'COMPLETED' as BookingItemStatusEnum
  );
};
